import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import CommonFormLabel from "../../../../components/common-form-label";
import Switch from "../../../../components/switch/index";
import Input from "../../../../components/input/index";
import SelectBox from "../../../../components/select-box/index";
import ColorPicker from "react-best-gradient-color-picker";
import CommomButton from "../../../../components/common-button/index";
import Range from "../../../../components/range/index";
import {
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Image as Img,
} from "react-bootstrap";
import { Label } from "reactstrap";
import { PDFDocument, rgb } from "pdf-lib";
import { pdfjs } from "react-pdf";
import { Image, Layer, Stage, Text, Transformer } from "react-konva";
import fontkit from "@pdf-lib/fontkit";
import useImage from "use-image";
import NotoSerifGujarati from "../Fonts/NotoSerifGujarati.ttf";
import { fontStyleOptions, positionOptions } from "../Fonts-Demo/FontStyles";
import { useParams } from "react-router-dom";
import { pdfToBase64File } from "../common/Common";
import "../styleModule.css";
import moment from "moment";
import { useSelector } from "react-redux";
import axiosApi from "../../../../utilities/axiosApi";
import {
  ColorPickerIcon,
  FileDownloadIcon,
  SearchMinusIcon,
  SearchAddIcon,
} from "../../../../icons/icons";
import { AlignLeft, AlignCenter, AlignRight } from "react-feather";

const URLImage = ({ image, onLoad }) => {
  const [img] = useImage(image);

  useEffect(() => {
    if (img) onLoad(img);
  }, [img, onLoad]);

  return <Image image={img} x={0} y={0} />;
};

const loadFont = async (name, url) => {
  try {
    // console.log("Family nsamae  :::: ", name, " :::: file ::::: ", url);
    const font = new FontFace(name, `url(${url})`);
    // console.log("FOnts :::::: ", font);
    await font.load();
    document.fonts.add(font);
    // console.log(`${name} font loaded`);
  } catch (error) {
    console.error("Error loading font:", error);
  }
};

const EditPdf = ({
  // stepper,
  tableData,
  csvKeys,
  totalPages,
  pagesUrl,
  file,
  fileType,
  messageData,
  formData,
  setFormData,
  setPos,
  pos,
  inputdata,
  formError,
  campaingDetails,
  isTestOpen,
  setIsTestOpen,
  handleTestClick,
}) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const { id } = useParams();

  // const navigate = useNavigate();
  const stageRef = useRef(null);
  const didInitPage = useRef({});
  // const { state } = useLocation();
  // const MySwal = withReactContent(Swal);

  const [currentPage, setCurrentPage] = useState(1);

  // const [optionsVisible, setOptionsVisible] = useState({
  //   visible: false,
  //   key: -1,
  // });
  const [testMobile, setTestMobile] = useState("");
  // const [sendMessageLoading, setSendMessageLoading] = useState(false);
  // const [
  //   messageProgress,
  //   // setMessageProgress
  // ] = useState(0);
  // const [testProgress, setTestProgress] = useState(false);
  // const [messagePreview, setMessagePreview] = useState("");



  // Color Pickker Toogle
  // const [color, setColor] = useState("rgba(255,255,255,1)");

  // const [colorPicker, SetColorPicker] = useState(false);
  // const colorPickerRef = useRef(null);

  // const handlechangeOpen = () => {
  //   SetColorPicker((prev) => !prev);
  // };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       colorPickerRef.current &&
  //       !colorPickerRef.current.contains(event.target)
  //     ) {
  //       SetColorPicker(false); // Close the color picker if clicked outside
  //     }
  //   };

  //   if (colorPicker) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [colorPicker]);
  // Color Pickker Toogle

  const colorPickerRefs = useRef({});
  const [colorPickers, setColorPickers] = useState({});

  const handleToggleColorPicker = (key, event) => {
    event.stopPropagation();
    setColorPickers((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleClickOutside = (event) => {
    Object.keys(colorPickerRefs.current).forEach((key) => {
      if (
        colorPickerRefs.current[key] &&
        !colorPickerRefs.current[key].contains(event.target)
      ) {
        setColorPickers((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
    });
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const expiry_date = useSelector((state) => state.auth.user.expiry_date);

  const [modalSchedule, setModalSchedule] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const textRefs = useRef({});
  const transformerRefs = useRef({});

  // State for managing zoom level
  const containerRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const maxZoom = 3;
  const minZoom = 0;
  // const [stagePosition, setStagePosition] = useState({ x: 0, y: 0 });
  const [selectedTextKey, setSelectedTextKey] = useState(null);
  const [stageSize, setStageSize] = useState({
    width: 500,
    height: 649,
  });

  useEffect(() => {
    fontStyleOptions.forEach((fontOption) => {
      loadFont(fontOption.value, fontOption.file); // Load each font dynamically
    });
  }, []);

  useEffect(() => {
    didInitPage.current[currentPage] = false;
  }, [currentPage]);

  useEffect(() => {
    if (selectedTextKey && transformerRefs.current[selectedTextKey]) {
      transformerRefs.current[selectedTextKey].nodes([
        textRefs.current[selectedTextKey],
      ]);
      transformerRefs.current[selectedTextKey].getLayer().batchDraw();
    }
  }, [selectedTextKey]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Define the move amount based on whether Ctrl is pressed
      const moveAmount = e.ctrlKey ? 10 : 0.1;

      const isArrowKey = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
      ].includes(e.key);

      if (
        selectedTextKey &&
        pos[selectedTextKey]?.page === currentPage &&
        isArrowKey
      ) {
        e.preventDefault();
        // Right Arrow
        if (e.key === "ArrowRight") {
          setPos((prevPos) => ({
            ...prevPos,
            [selectedTextKey]: {
              ...prevPos[selectedTextKey],
              x: prevPos[selectedTextKey].x + moveAmount,
            },
          }));
        }

        // Left Arrow
        if (e.key === "ArrowLeft") {
          setPos((prevPos) => ({
            ...prevPos,
            [selectedTextKey]: {
              ...prevPos[selectedTextKey],
              x: prevPos[selectedTextKey].x - moveAmount,
            },
          }));
        }

        // Up Arrow
        if (e.key === "ArrowUp") {
          setPos((prevPos) => ({
            ...prevPos,
            [selectedTextKey]: {
              ...prevPos[selectedTextKey],
              y: prevPos[selectedTextKey].y - moveAmount,
            },
          }));
        }

        // Down Arrow
        if (e.key === "ArrowDown") {
          setPos((prevPos) => ({
            ...prevPos,
            [selectedTextKey]: {
              ...prevPos[selectedTextKey],
              y: prevPos[selectedTextKey].y + moveAmount,
            },
          }));
        }
      }
    };

    // Add the event listener
    window.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [pos, setPos, currentPage, selectedTextKey]);

  // Function to handle zoom in
  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.01, maxZoom));
  };

  // Function to handle zoom out
  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.01, minZoom));
  };

  // const handleWheel = (e) => {
  //   e.evt.preventDefault();

  //   const scaleBy = 1.05;
  //   const stage = stageRef.current;
  //   const oldScale = stage.scaleX();

  //   if (e.evt.ctrlKey) {
  //     // Zoom when Ctrl is pressed
  //     const mousePointTo = {
  //       x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
  //       y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale,
  //     };
  //     const newScale =
  //       e.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;
  //     setZoomLevel(newScale);
  //     stage.scale({ x: newScale, y: newScale });
  //     const newPos = {
  //       x:
  //         -(mousePointTo.x - stage.getPointerPosition().x / newScale) *
  //         newScale,
  //       y:
  //         -(mousePointTo.y - stage.getPointerPosition().y / newScale) *
  //         newScale,
  //     };
  //     stage.position(newPos);
  //   } else {
  //     // Scroll behavior
  //     const newPosition = {
  //       x: stagePosition.x - e.evt.deltaX,
  //       y: stagePosition.y - e.evt.deltaY,
  //     };
  //     setStagePosition(newPosition);
  //     stage.position(newPosition);
  //   }
  // };
  const updateStageSize = useCallback(() => {
    if (containerRef.current && pagesUrl.length > 0) {
      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;

      // Get the current page dimensions
      const pageWidth = pagesUrl[currentPage - 1]?.width || containerWidth;
      const pageHeight = pagesUrl[currentPage - 1]?.height || containerHeight;

      // Calculate scale factor to fit the page into the container
      const scaleX = containerWidth / pageWidth;
      const scaleY = containerHeight / pageHeight;
      const scaleFactor = Math.min(scaleX, scaleY); // Use the smaller scale to fit both width and height

      setZoomLevel(scaleFactor); // Set initial zoom level to fit the document

      setStageSize({
        width: pageWidth * scaleFactor,
        height: pageHeight * scaleFactor,
      });

      // Adjust the default font size based on document size
      // const scaledFontSize = 18 * scaleFactor; // Adjust the default font size proportionally
      // setDefaultFontSize(Math.max(12, scaledFontSize)); // Ensure font size doesn't get too small
    }
  }, [pagesUrl, currentPage]);

  // console.log("pagesUrl", pagesUrl);

  useEffect(() => {
    // Update the stage size when the window or container changes size or page changes
    updateStageSize();
    window.addEventListener("resize", updateStageSize);
    return () => window.removeEventListener("resize", updateStageSize);
  }, [updateStageSize]);

  const toggleSchedule = () => setModalSchedule(!modalSchedule);

  const handleImageLoad = (img) => {
    // Wait until DOM has mounted
    if (!containerRef.current) return;

    // Prevent infinite re-calculations
    if (didInitPage.current[currentPage]) return;
    didInitPage.current[currentPage] = true;

    setTimeout(() => {
      if (!containerRef.current) return;

      const pageWidth = img.width;
      const pageHeight = img.height;

      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;

      const scaleX = containerWidth / pageWidth;
      const scaleY = containerHeight / pageHeight;
      const scaleFactor = Math.min(scaleX, scaleY);

      setZoomLevel(scaleFactor);

      setStageSize({
        width: pageWidth * scaleFactor,
        height: pageHeight * scaleFactor,
      });
    }, 0);
  };

  const toggleTestModal = () => {
    setTestMobile("");
    setIsSubmitting(false);
    setIsTestOpen(!isTestOpen);
  };
  // const toggleOptionVisible = (key) =>
  //   setOptionsVisible(
  //     optionsVisible?.visible === true
  //       ? { visible: false, key: -1 }
  //       : { visible: true, key: key }
  //   );

  // function onDocumentLoadSuccess({ numPages }) {
  //   console.log("numpagessss", numPages);
  // }

  // console.log("tableData",tableData);

  useEffect(() => {
    let newMessage = messageData;
    console.log("newMessage",newMessage);
    console.log("csvKeys",csvKeys);
    console.log("tableData",tableData);
    csvKeys?.forEach((item) => {
      console.log("item",item);
      console.log("tableData[0]",tableData?.[0]);
      console.log("tableData[0][item]",tableData?.[0]?.[item]);
      // console.log("tableData",tableData?.[0]?.[item]?.trim());
      console.log("typeof tableData?.[0]?.[item]",typeof tableData?.[0]?.[item]);
      
      newMessage = newMessage?.replaceAll(
        `[[${item}]]`,
        typeof tableData?.[0]?.[item] === "string" ? tableData?.[0]?.[item]?.trim() : tableData?.[0]?.[item]
      );
    });
    console.log("newMessage",newMessage);
    // setMessagePreview(newMessage);
  }, [messageData, csvKeys, tableData]);

  const sendTestMessage = async () => {
    if (!testMobile) {
      //   notification({
      //     type: "error",
      //     title: "Please enter Mobile number",
      //   });
    } else {
      setIsSubmitting(true);

      try {
        // Determine sender type from campaign details
        const senderType = campaingDetails?.sender_type || "personal";

        // Build request payload for Laravel API
        const payload = {
          campaign_id: id,
          numbers: testMobile,
          name: "Test Message",
          sender_type: senderType,
          delay: formData?.delaySecond || 0,
        };

        // The guest row the placeholders are filled from. Official sends turn
        // it into Meta's body parameters; personal sends hand it to Node,
        // which re-renders the guest's copy of the PDF from it.
        if (tableData?.[0]) {
          payload.tb_data = JSON.stringify(tableData[0]);
        }

        // For official sender with Meta templates.
        // The API exposes the column name, meta_message_template_id -- reading
        // meta_template_id here left it undefined and every official test came
        // back "Meta template is required for official sender."
        if (senderType === "official" && campaingDetails?.meta_message_template_id) {
          payload.meta_template_id = campaingDetails.meta_message_template_id;

          // Which guest column fills each {{n}} is answered per campaign, and
          // imported templates carry no map of their own, so without this the
          // body parameters go out empty and Meta rejects the send.
          if (campaingDetails?.template_variable_map) {
            payload.template_variable_map = JSON.stringify(
              campaingDetails.template_variable_map
            );
          }

          // Build message from messageData
          let newMessage = messageData;
          csvKeys.forEach((item) => {
            newMessage = newMessage.replaceAll(
              `[[${item}]]`,
              tableData[0][item]?.replaceAll(/;/g, ",").trim() || ""
            );
          });
          payload.message = newMessage;

          // Note: For Meta templates with IMAGE/VIDEO/DOCUMENT headers,
          // Laravel will fetch the media from campaign.template_url
          // No need to send file here
        }
        // For personal sender (old flow with file upload)
        else {
          // Build message with variables replaced
          let newMessage = messageData;
          csvKeys.forEach((item) => {
            newMessage = newMessage.replaceAll(
              `[[${item}]]`,
              tableData[0][item]?.replaceAll(/;/g, ",").trim() || ""
            );
          });
          payload.message = newMessage;

          // If campaign has file, Laravel will use campaign.template_url
          // No need to upload file here anymore
        }

        // Call Laravel API (it will route to official or personal appropriately)
        const response = await axiosApi.post(
          '/api/customer/send-test-message',
          payload
        );

        console.log("Test message response:", response.data);

        setTestMobile("");
        setIsSubmitting(false);
        toggleTestModal();

        // Show success notification
        // notification({
        //   type: "success",
        //   title: "Test message sent successfully!",
        // });

      } catch (error) {
        console.error("Test message error:", error);
        setIsSubmitting(false);

        // Show error notification
        // notification({
        //   type: "error",
        //   title: error.response?.data?.message || "Failed to send test message",
        // });
      }
    }
  };

  // console.log(pagesUrl[currentPage - 1]?.height);

  const changeFont = async (data) => {
    const existingPdfBytes = await fetch(URL.createObjectURL(file)).then(
      (res) => res.arrayBuffer()
    );
    const pdfDocs1 = await PDFDocument.load(existingPdfBytes, {
      ignoreEncryption: true,
    });
    pdfDocs1.registerFontkit(fontkit);
    const pages = pdfDocs1.getPages();

    let embeddedFonts = [];
    for (let key in pos) {
      const fontObject = pos[key];
      const fontBytes = await fetch(fontObject.fontFile).then((res) =>
        res.arrayBuffer()
      );
      await fontkit.create(fontBytes);
      const embeddedFont = await pdfDocs1.embedFont(fontBytes, {
        subset: true,
      });
      embeddedFonts.push(embeddedFont);
    }

    let index = 0;
    for (let key in pos) {
      const page = pages[pos[key].page - 1];
      const { height: pageHeight } = page.getSize();

      const {
        x,
        y,
        width = 200,
        align = "left",
        size = 18,
        color = [0, 0, 0],
        underline = false,
      } = pos[key];

      const text = data[key]?.replaceAll(/;/g, ",") || "";
      const font = embeddedFonts[index];
      const textHeight = embeddedFonts[index].sizeAtHeight(pos[key]?.size);

      const wrapText = (text, maxWidth, font, fontSize) => {
        const words = text.split(" ");
        const lines = [];
        let line = "";

        for (let i = 0; i < words.length; i++) {
          let word = words[i];
          let testLine = line + word + " ";
          let testWidth = font.widthOfTextAtSize(testLine, fontSize);

          if (testWidth <= maxWidth) {
            line = testLine;
          } else {
            if (font.widthOfTextAtSize(word, fontSize) > maxWidth) {
              // Word is too long — break it char by char
              for (let j = 0; j < word.length; j++) {
                const testCharLine = line + word[j];
                if (font.widthOfTextAtSize(testCharLine, fontSize) > maxWidth) {
                  lines.push(line);
                  line = word[j];
                } else {
                  line = testCharLine;
                }
              }
              line += " "; // Add space after word
            } else {
              lines.push(line.trim());
              line = word + " ";
            }
          }
        }
        if (line.length > 0) lines.push(line.trim());
        return lines;
      };

      const lines = wrapText(text, width, font, size);

    const lineHeight = size * 1.34;
      const totalTextHeight = lines.length * lineHeight;

      const startY = pageHeight - y;

      lines.forEach((line, lineIndex) => {
        const textWidth = font.widthOfTextAtSize(line, size);

        let adjustedX = x;
        if (align === "center") {
          adjustedX = x + (width - textWidth) / 2;
        } else if (align === "right") {
          adjustedX = x + (width - textWidth);
        }

        const lineY = startY - totalTextHeight + lineIndex * lineHeight;

        page.drawText(line, {
          x: adjustedX,
          y: lineY+
            textHeight -
            (textHeight >= 46
              ? 7
              : textHeight >= 30
                ? 6
                : textHeight >= 12
                  ? 3
                  : 1),
          size,
          font,
          color: rgb(color[0] / 255, color[1] / 255, color[2] / 255),
        });

        if (underline) {
          const underlineY = lineY - 2;
          page.drawLine({
            start: { x: adjustedX, y: underlineY },
            end: { x: adjustedX + textWidth, y: underlineY },
            thickness: 1,
            color: rgb(color[0] / 255, color[1] / 255, color[2] / 255),
          });
        }
      });

      index++;
    }

    pdfDocs1.setTitle("");
    pdfDocs1.setAuthor("");
    pdfDocs1.setSubject("");
    pdfDocs1.setProducer("");
    pdfDocs1.setCreator("");
    const pdfBytes = await pdfDocs1.save();
    return pdfBytes;
  };

  const downloadPDF = async () => {
    const link = document.createElement("a");
    const pdfBytes = await changeFont(tableData[0]);
    let file = new File([pdfBytes], "test-Certificate.pdf", {
      type: "application/pdf;charset=utf-8",
    });
    if (fileType === "application/pdf") {
      const encodedUri = window.URL.createObjectURL(file);
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${tableData[0]?.name}.pdf`);
    } else {
      const dataURL = await pdfToBase64File(
        window.URL.createObjectURL(file),
        fileType
      );
      link.setAttribute("href", dataURL);
      link.setAttribute(
        "download",
        `${tableData[0].name}${fileType === "image/png" ? ".png" : ".jpeg"}`
      );
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDragEnd = (e, key) => {
    // const textNode = e.target;
    // setPos({
    //   ...pos,
    //   [key]: {
    //     ...pos[`${key}`],
    //     x: textNode.x(),
    //     y: textNode.y(),
    //   },
    // });
    // setSelectedTextKey(key);
    // console.log("Text Node :::::: ", e.target);
    const textNode = e.target;
    setPos((prevPos) => ({
      ...prevPos,
      [key]: {
        ...prevPos[key],
        x: textNode.x(),
        y: textNode.y(),
      },
    }));
    setSelectedTextKey(key);
  };

  const componentToHex = (c) => {
    var hex = c?.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  const rgbToHex = (color) =>
    "#" +
    componentToHex(color[0]) +
    componentToHex(color[1]) +
    componentToHex(color[2]);

  // console.log("Font ::::::: ", pos);
  // console.log("Selected ::::::: ", selectedTextKey);
  // console.log("CUrrunt page ::::::: ", currentPage);

  const handleZoomChange = (e) => {
    const newZoomLevel = parseFloat(e.target.value);
    // console.log("ZOOOOOM ::::::: ", e.target.value);
    setZoomLevel(newZoomLevel);
  };

  const getTextWidth = (text, size, font) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.font = `${size}px ${font}`;
    return ctx.measureText(text).width;
  };

  const getTextHeight = (size) => {
    return size; // Approximate height as size
  };

  const calculateAlignedPosition = ({
    text,
    size,
    font,
    pageWidth,
    pageHeight,
    align,
    padding = 20, // added flexibility
  }) => {
    const textWidth = getTextWidth(text, size, font);
    const textHeight = getTextHeight(size);

    let x = padding;
    let y = padding + textHeight;

    // console.log("textHeight :: ",textHeight);
    // console.log("x :: ",x);
    // console.log("y :: ",y);

    switch (align) {
      case "top-left":
        x = padding;
        y = padding + textHeight;
        break;
      case "top-middle":
        x = (pageWidth - textWidth) / 2;
        y = padding + textHeight;
        break;
      case "top-right":
        x = pageWidth - textWidth - padding;
        y = padding + textHeight;
        break;
      case "center-left":
        x = padding;
        y = (pageHeight + textHeight) / 2;
        break;
      case "center":
        // x = (pageWidth - textWidth) / 2;
        x = (pageWidth + textWidth) / 14;
        y = pageHeight / 2;
        // y = (pageHeight + textHeight) / 2;
        break;
      case "center-right":
        x = pageWidth - textWidth - padding;
        y = (pageHeight + textHeight) / 2;
        break;
      case "bottom-left":
        x = padding;
        y = pageHeight - padding;
        break;
      case "bottom-middle":
        x = (pageWidth - textWidth) / 2;
        y = pageHeight - padding;
        break;
      case "bottom-right":
        x = pageWidth - textWidth - padding;
        y = pageHeight - padding;
        break;
      default:
        x = padding;
        y = padding + textHeight;
    }

    return { x, y };
  };

  const handleStageMouseDown = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    const isNotRectOrText = !["Text", "Rect"].includes(e.target.className);

    if (clickedOnEmpty || isNotRectOrText) {
      setSelectedTextKey(null); // Deselect text
    }
  };

  return (
    <Fragment>
      <>
        <Row>
          <Col xs={12} lg={12} xl={12} xxl={4}>
            <div className="bg-white rounded-2 common-shadow px-3 py-4 mb-4">
              <div className="send-invitaion-left-content">
                <h5 className="fw-medium">Customize PDF</h5>
                <div className="my-4 h-divider "></div>
                {tableData &&
                  tableData?.length > 0 &&
                  Object.keys(tableData[0]).map((data, index) => {
                    // console.log("Datatatatatat :::::::: ", pos[data]);
                    const dynamicClass = `box-color-${index % 10}`; // Cycle through 4 styles
                    return (
                      index !== 1 && (
                        <>
                          <div
                            className={`d-flex align-items-center justify-content-between gap-3 mb-4 my-4  ${dynamicClass}`}
                          >
                            <p className="fw-medium">{data}</p>
                            <div className="d-flex align-items-center gap-2">
                              <p className="fw-medium">Edit</p>
                              <Switch
                                type="switch"
                                id="custom-switch"
                                className="sm-switch"
                                checked={pos[data] ? true : false}
                                onChange={() => {
                                  const pageWidth =
                                    pagesUrl[currentPage - 1]?.width || 600; // Default width if not available
                                  const pageHeight =
                                    pagesUrl[currentPage - 1]?.height || 800; // Default height if not available

                                  // console.log(
                                  //   pagesUrl[currentPage - 1]?.width,
                                  //   pagesUrl[currentPage - 1]?.height
                                  // );

                                  // Calculate an appropriate initial font size as a percentage of the page dimensions
                                  const baseFontSize = 18; // The reference font size for typical dimensions
                                  const referenceWidth = 600; // Reference width for the base font size
                                  const referenceHeight = 800; // Reference height for the base font size

                                  // Use the smaller of the width or height scaling factor to determine the font size
                                  const widthScale = pageWidth / referenceWidth;
                                  const heightScale =
                                    pageHeight / referenceHeight;
                                  const scaleFactor = Math.max(
                                    widthScale,
                                    heightScale
                                  ); // Keep proportions consistent

                                  // Set the initial font size based on the scale factor
                                  const initialFontSize = Math.round(
                                    baseFontSize * scaleFactor
                                  );
                                  setPos((prevPos) => {
                                    const newPos = { ...prevPos };
                                    if (newPos[data]) {
                                      delete newPos[data];
                                    } else {
                                      const text =
                                        tableData[0][data]?.toString() || data;
                                      const font = "NotoSerifGujarati"; // default font
                                      const fontSize = initialFontSize;

                                      // Create temp canvas to measure
                                      const canvas =
                                        document.createElement("canvas");
                                      const context = canvas.getContext("2d");
                                      context.font = `${fontSize}px ${font}`;
                                      const textMetrics =
                                        context.measureText(text);

                                      const padding = 40; // increased padding
                                      const lineHeightMultiplier = 2; // increased height multiplier

                                      const textWidth =
                                        textMetrics.width + padding;
                                      const textHeight =
                                        fontSize * lineHeightMultiplier;

                                      newPos[data] = {
                                        text,
                                        page: currentPage,
                                        x: 1,
                                        y: 1,
                                        color: [0, 0, 0],
                                        size: fontSize,
                                        fontStyle: font,
                                        fontFile: NotoSerifGujarati,
                                        align: "left",
                                        width: textWidth,
                                        height: textHeight,
                                      };
                                    }
                                    return newPos;
                                  });
                                }}
                              />
                            </div>
                          </div>
                          {pos[data] && (
                            <div>
                              <div>
                                <CommonFormLabel title="Text Align" />
                                <div className="d-flex gap-2 mb-3">
                                  <CommomButton
                                    icon={<AlignLeft size={16} />}
                                    className={`custom-outline-btn py-1 px-3 d-flex align-items-center justify-content-center ${
                                      pos[data]?.align === "left"
                                        ? "btn-primary text-white"
                                        : "btn-outline-primary"
                                    }`}
                                    onClick={() =>
                                      setPos((prev) => ({
                                        ...prev,
                                        [data]: {
                                          ...prev[data],
                                          align: "left",
                                        },
                                      }))
                                    }
                                  />

                                  <CommomButton
                                    icon={<AlignCenter size={16} />}
                                    className={`custom-outline-btn py-1 px-3 d-flex align-items-center justify-content-center ${
                                      pos[data]?.align === "center"
                                        ? "btn-primary text-white"
                                        : "btn-outline-primary"
                                    }`}
                                    onClick={() =>
                                      setPos((prev) => ({
                                        ...prev,
                                        [data]: {
                                          ...prev[data],
                                          align: "center",
                                        },
                                      }))
                                    }
                                  />

                                  <CommomButton
                                    icon={<AlignRight size={16} />}
                                    className={`custom-outline-btn py-1 px-3 d-flex align-items-center justify-content-center ${
                                      pos[data]?.align === "right"
                                        ? "btn-primary text-white"
                                        : "btn-outline-primary"
                                    }`}
                                    onClick={() =>
                                      setPos((prev) => ({
                                        ...prev,
                                        [data]: {
                                          ...prev[data],
                                          align: "right",
                                        },
                                      }))
                                    }
                                  />
                                </div>
                                {/* <CommonFormLabel title="Text Style" />
                                  <div className="d-flex gap-2 mb-3">
                                    <CommomButton
                                      title="Bold"
                                      className={`custom-outline-btn py-1 px-3 ${pos[data]?.bold ? 'btn-primary text-white' : 'btn-outline-primary'}`}
                                      onClick={() =>
                                        setPos((prev) => ({
                                          ...prev,
                                          [data]: {
                                            ...prev[data],
                                            bold: !prev[data].bold,
                                          },
                                        }))
                                      }
                                    />
                                    <CommomButton
                                      title="Italic"
                                      className={`custom-outline-btn py-1 px-3 ${pos[data]?.italic ? 'btn-primary text-white' : 'btn-outline-primary'}`}
                                      onClick={() =>
                                        setPos((prev) => ({
                                          ...prev,
                                          [data]: {
                                            ...prev[data],
                                            italic: !prev[data].italic,
                                          },
                                        }))
                                      }
                                    />
                                    <CommomButton
                                      title="Underline"
                                      className={`custom-outline-btn py-1 px-3 ${pos[data]?.underline ? 'btn-primary text-white' : 'btn-outline-primary'}`}
                                      onClick={() =>
                                        setPos((prev) => ({
                                          ...prev,
                                          [data]: {
                                            ...prev[data],
                                            underline: !prev[data].underline,
                                          },
                                        }))
                                      }
                                    />
                                  </div> */}

                                <CommonFormLabel title="Select Font" />
                                <SelectBox
                                  staticOption="Please Choose a Fonts..."
                                  data={fontStyleOptions}
                                  value={pos[data]?.fontStyle || ""}
                                  onChange={(e) => {
                                    setPos((prevPos) => {
                                      const newPos = { ...prevPos }; // Clone the previous state object
                                      newPos[data] = {
                                        //
                                        // Clone the nested object to avoid mutating the original
                                        ...prevPos[data],
                                        fontStyle: e.target.value,
                                        fontFile: fontStyleOptions?.find(
                                          (option) =>
                                            option?.value === e.target.value
                                        ).file,
                                      };
                                      return newPos; // Return the new updated state object
                                    });
                                  }}  
                                />
                              </div>
                              <div className="mt-3">
                                <CommonFormLabel title="Select Position" />
                                <SelectBox
                                  staticOption="Please Choose a Position..."
                                  data={positionOptions}
                                  value={pos[data]?.position || ""} // ✅ change to position
                                  onChange={(e) => {
                                    const selectedPosition = e.target.value;
                                    const textValue =
                                      tableData?.[0]?.[data]?.toString() || "";
                                    const size = pos[data]?.size || 18;
                                    const font =
                                      pos[data]?.fontStyle ||
                                      "NotoSerifGujarati";
                                    const pageWidth =
                                      pagesUrl[currentPage - 1]?.width || 595;
                                    const pageHeight =
                                      pagesUrl[currentPage - 1]?.height || 842;

                                    const { x, y } = calculateAlignedPosition({
                                      text: textValue,
                                      size,
                                      font,
                                      pageWidth,
                                      pageHeight,
                                      align: selectedPosition,
                                    });

                                    setPos((prev) => ({
                                      ...prev,
                                      [data]: {
                                        ...prev[data],
                                        x,
                                        y,
                                        position: selectedPosition, // ✅ Save position separately
                                      },
                                    }));
                                  }}
                                />
                              </div>
                              <div className="grid mt-3 gap-3">
                                <div
                                  className="g-col-6"
                                  style={{ position: "relative" }}
                                >
                                  <CommonFormLabel title="Font Size" />
                                  <Input
                                    type="number"
                                    placeholder="Enter Font Size"
                                    className="shadow-none"
                                    value={pos[data].size}
                                    onChange={(e) => {
                                      const newSize = parseInt(
                                        e.target.value.replace(/[^0-9]/g, "")
                                      );
                                      // Ensure we're not modifying the original object
                                      setPos((prevPos) => {
                                        // Return a new copy of the pos object, and update the specific property immutably
                                        return {
                                          ...prevPos,
                                          [data]: {
                                            ...prevPos[data],
                                            size: newSize, // Update the font size immutably
                                          },
                                        };
                                      });
                                    }}
                                  />
                                  {/* <NumberInputArrowUpIcon className="input-number-field-up-arrow"/>
                                  <NumberInputArrowDownIcon className="input-number-field-down-arrow"/> */}
                                </div>

                                <div className="g-col-6">
                                  <CommonFormLabel title="Select Color" />

                                  <div className="position-relative">
                                    <Input
                                      type="text"
                                      // placeholder="#000000"
                                      className="shadow-none custom-color-picker"
                                      minLength={4}
                                      maxLength={7}
                                      value={rgbToHex(pos[data]?.color)}
                                      disabled={true}
                                      // onChange={(e) => {
                                      //   let hexValue = e.target.value;
                                      //   let rgbValue = [
                                      //     ("0x" + hexValue[1] + hexValue[2]) |
                                      //       0,
                                      //     ("0x" + hexValue[3] + hexValue[4]) |
                                      //       0,
                                      //     ("0x" + hexValue[5] + hexValue[6]) |
                                      //       0,
                                      //   ];
                                      //   setPos((prevPos) => {
                                      //     const newPos = { ...prevPos };
                                      //     newPos[data].color = rgbValue;
                                      //     return newPos;
                                      //   });
                                      // }}
                                    />
                                    <div className="position-absolute top-50 end-0 translate-middle-y me-1 z-15">
                                      <div className=" position-relative">
                                        <CommomButton
                                          icon={
                                            <ColorPickerIcon
                                              width={18}
                                              height={18}
                                              color="#ffffff"
                                              strokeWidth="2"
                                            />
                                          }
                                          // onClick={handlechangeOpen}
                                          onClick={(e) =>
                                            handleToggleColorPicker(data, e)
                                          }
                                          className="btn-primary primary-shadow py-1 px-2 "
                                        />
                                        {colorPickers[data] && (
                                          <div
                                            className=" position-absolute top-100 end-0 mt-3"
                                            ref={(el) =>
                                              (colorPickerRefs.current[data] =
                                                el)
                                            }
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <ColorPicker
                                              className="border rounded-2 shadow-none"
                                              value={rgbToHex(pos[data]?.color)}
                                              onChange={(color) => {
                                                // console.log(
                                                //   "COCOCOCOCOCO : ",
                                                //   color
                                                // );
                                                const rgbValues = color.match(
                                                  /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
                                                );
                                                if (rgbValues) {
                                                  const newColor = [
                                                    parseInt(rgbValues[1]),
                                                    parseInt(rgbValues[2]),
                                                    parseInt(rgbValues[3]),
                                                  ];
                                                  if (rgbValues[4]) {
                                                    newColor.push(
                                                      parseFloat(rgbValues[4])
                                                    );
                                                  }
                                                  setPos({
                                                    ...pos,
                                                    [data]: {
                                                      ...pos[`${data}`],
                                                      color: newColor,
                                                    },
                                                  });
                                                }
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr class="hr-dotted-large" />
                            </div>
                          )}
                        </>
                      )
                    );
                  })}
              </div>
            </div>
          </Col>
          <Col xs={12} lg={12} xl={12} xxl={8}>
            <div className="bg-white rounded-2 common-shadow px-3 py-4 mb-4">
              <div className="send-invitaion-right-content">
                <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                  <h5 className="fw-medium">File Preview</h5>
                  <div className="d-flex align-items-center gap-3">
                    {/* <CommomButton
                      icon={
                        <ReloadIcon
                          width={15}
                          height={15}
                          color="#A5596A"
                          strokeWidth="2.5"
                        />
                      }
                      title="Refresh"
                      className="btn-outline-primary bg-transparent "
                      subClassName="gap-2"
                    /> */}
                    <CommomButton
                      icon={
                        <FileDownloadIcon
                          width={15}
                          height={15}
                          color="#A5596A"
                          strokeWidth="2.5"
                        />
                      }
                      title="Download"
                      className="btn-outline-primary bg-transparent "
                      onClick={() => downloadPDF()}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-start justify-content-between gap-3">
                  <div
                    className=" flex-grow-1 d-inline-block"
                    ref={containerRef}
                  >
                    <Stage
                      id="stage"
                      ref={stageRef}
                      width={stageSize.width}
                      height={stageSize.height}
                      className="overflow-hidden pdf-preview-content"
                      scaleX={zoomLevel}
                      scaleY={zoomLevel}
                      draggable
                      onMouseDown={handleStageMouseDown} // ✅ added
                    >
                      <Layer>
                        <URLImage
                          image={pagesUrl[currentPage - 1]?.base64}
                          onLoad={handleImageLoad}
                        />

                        {Object.keys(pos).map((key) => {
                          if (pos[key]?.page === currentPage) {
                            const text = (
                              tableData?.[0]?.[key] || ""
                            ).toString();

                            return (
                              <Fragment key={key}>
                                {/* {selectedTextKey === key && (
                                <Rect
                                  x={pos[key]?.x}
                                  y={pos[key]?.y}
                                width={pos[key]?.width}
                                height={pos[key]?.height}
                                  fill="transparent"
                                  stroke="rgba(0,0,0,1)"
                                  strokeWidth={1}
                                  onMouseEnter={(e) => {
                                    e.target.getStage().container().style.cursor = "move";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.getStage().container().style.cursor = "default";
                                  }}
                                  listening={false}
                                />
                              )} */}

                                <Text
                                  ref={(node) => (textRefs.current[key] = node)}
                                  text={text}
                                  x={pos[key]?.x}
                                  y={pos[key]?.y}
                                  width={pos[key]?.width}
                                  height={pos[key]?.height + 25}
                                  wrap="word"
                                  ellipsis={false}
                                  listening={true}
                                  lineHeight={1.2}
                                  align={pos[key]?.align || "left"}
                                  verticalAlign="top"
                                  fontSize={pos[key]?.size}
                                  fontFamily={pos[key]?.fontStyle}
                                  fill={`rgba(${pos[key]?.color[0]}, ${pos[key]?.color[1]}, ${pos[key]?.color[2]})`}
                                  draggable
                                  onMouseEnter={(e) => {
                                    const container = e.target
                                      .getStage()
                                      .container();
                                    container.style.cursor = "move"; // ✅ show move cursor in
                                  }}
                                  onMouseLeave={(e) => {
                                    const container = e.target
                                      .getStage()
                                      .container();
                                    container.style.cursor = "default"; // ✅ reset cursor
                                  }}
                                  onClick={() => setSelectedTextKey(key)}
                                  onTransform={(e) => {
                                    const node = textRefs.current[key];
                                    const scaleX = node.scaleX();
                                    const scaleY = node.scaleY();

                                    // Immediately reset the visual scale during transform
                                    node.scaleX(1);
                                    node.scaleY(1);

                                    // Apply updated width/height live to fix font shrinking issue
                                    const updatedWidth = Math.max(
                                      30,
                                      node.width() * scaleX
                                    );
                                    const updatedHeight = Math.max(
                                      20,
                                      node.height() * scaleY
                                    );
                                    node.width(updatedWidth);
                                    node.height(updatedHeight);
                                  }}
                                  onTransformEnd={(e) => {
                                    const node = textRefs.current[key];
                                    const scaleX = node.scaleX();
                                    // const scaleY = node.scaleY();

                                    // Reset scale
                                    node.scaleX(1);
                                    node.scaleY(1);

                                    const updatedWidth = Math.max(
                                      30,
                                      node.width() * scaleX
                                    );

                                    const text = node.text();
                                    const fontSize = pos[key]?.size || 18;
                                    const fontFamily =
                                      pos[key]?.fontStyle || "Arial";

                                    // Create a canvas context to measure text
                                    const canvas =
                                      document.createElement("canvas");
                                    const context = canvas.getContext("2d");
                                    context.font = `${fontSize}px ${fontFamily}`;

                                    const words = text.split(" ");
                                    let lines = [];
                                    let currentLine = "";

                                    for (let i = 0; i < words.length; i++) {
                                      const word = words[i];
                                      const testLine = currentLine + word + " ";
                                      const { width: testWidth } =
                                        context.measureText(testLine);
                                      if (
                                        testWidth > updatedWidth &&
                                        currentLine !== ""
                                      ) {
                                        lines.push(currentLine);
                                        currentLine = word + " ";
                                      } else {
                                        currentLine = testLine;
                                      }
                                    }
                                    lines.push(currentLine); // Add last line

                                    const lineHeight = fontSize * 1.2;
                                    const updatedHeight =
                                      lines.length * lineHeight;

                                    setPos((prev) => ({
                                      ...prev,
                                      [key]: {
                                        ...prev[key],
                                        x: node.x(),
                                        y: node.y(),
                                        width: updatedWidth,
                                        height: updatedHeight,
                                      },
                                    }));
                                  }}
                                  onDragEnd={(e) => handleDragEnd(e, key)}
                                />

                                {selectedTextKey === key && (
                                  <Transformer
                                    ref={(node) =>
                                      (transformerRefs.current[key] = node)
                                    }
                                    boundBoxFunc={(oldBox, newBox) => {
                                      if (
                                        newBox.width < 30 ||
                                        newBox.height < 20
                                      ) {
                                        return oldBox;
                                      }
                                      return newBox;
                                    }}
                                    rotateEnabled={false}
                                    enabledAnchors={[
                                      "top-left",
                                      "top-right",
                                      "bottom-left",
                                      "bottom-right",
                                      "middle-left",
                                      "middle-right",
                                      "top-center",
                                      "bottom-center",
                                    ]}
                                  />
                                )}
                              </Fragment>
                            );
                          }
                          return null;
                        })}
                      </Layer>
                    </Stage>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-3 flex-column flex-shrink-1  overflow-y-scroll img-view-content">
                    {pagesUrl.map((item, i) => {
                      const isActiveFilePreview = currentPage === i + 1;
                      return (
                        <Img
                          key={i}
                          src={item.base64}
                          className={`object-fit-contain img-view cursor-pointer ${
                            isActiveFilePreview ? "highlighted" : ""
                          }`}
                          height={132}
                          width={100}
                          alt="PDF Images"
                          onClick={() => setCurrentPage(i + 1)}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-center mt-4">
                  <div className="d-inline-block mx-auto">
                    <div className="d-flex align-items-center p-2  rounded-pill border gap-3">
                      <span className=" cursor-pointer" onClick={handleZoomOut}>
                        <SearchMinusIcon
                          width={20}
                          height={20}
                          color="#444050"
                          strokeWidth="2"
                        />
                      </span>

                      <Range
                        value={zoomLevel}
                        onChange={handleZoomChange}
                        min={0.5} // Minimum zoom level
                        max={3} // Maximum zoom level
                      />

                      <span className=" cursor-pointer" onClick={handleZoomIn}>
                        <SearchAddIcon
                          width={20}
                          height={20}
                          color="#444050"
                          strokeWidth="2"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* {file ? (
          <Row>
            <Col xl="12" className="mb-25 ">
              <Row className="pt-5">
                <Col md="3" className="border_rightcol pt-2">
                  <div className="d-flex justify-content-between align-items-center fw-bold ps-1 mb-2">
                    <h4>Add Values</h4>
                    <div className="d-flex justify-content-end">
                      <Button
                        id="refreshBtn"
                        className="btn-icon"
                        color="primary"
                        size="sm"
                        outline
                        style={{ margin: "5px" }}
                        onClick={async () => {
                          setPos({});
                          setCurrentPage(1);
                        }}
                      >
                        <RefreshCcw size={15} className="align-middle me-0" />
                        <UncontrolledTooltip
                          placement="bottom"
                          target="refreshBtn"
                        >
                          Refresh
                        </UncontrolledTooltip>
                      </Button>
                      <Button
                        id="downloadBtn"
                        className="btn-icon"
                        color="primary"
                        size="sm"
                        outline
                        style={{ margin: "5px" }}
                        onClick={() => downloadPDF()}
                      >
                        <Download size={15} className="align-middle ms-0" />
                        <UncontrolledTooltip
                          placement="bottom"
                          target="downloadBtn"
                        >
                          Download
                        </UncontrolledTooltip>
                      </Button>
                    </div>
                  </div>
                  <div className="edit_add_card mt-3">
                    <div className="cardbody_data">
                      {tableData &&
                        tableData?.length > 0 &&
                        Object.keys(tableData[0]).map((data, index) => {
                          // console.log("DATA :::::::: ", tableData[0][data]);
                          // setPos({
                          //   ...pos,
                          //   [data]: {
                          //     text: (
                          //       tableData[0][data] || data
                          //     ).replaceAll(/;/g, ","),
                          //   },
                          // });
                          return (
                            index !== 1 && (
                              <>
                                <div
                                  key={index}
                                  className={classNames(
                                    "d-flex justify-content-start align-items-center",
                                    {
                                      "mt-1": index === 0,
                                      // eslint-disable-next-line no-dupe-keys
                                      "mt-1": index !== 0,
                                    }
                                  )}
                                >
                                  <Col md="8">
                                    <p
                                      className="mb-0 text-start"
                                      style={{
                                        wordBreak: "break-word",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {(tableData[0][data] || data)?.replaceAll(
                                        /;/g,
                                        ","
                                      )}
                                    </p>
                                  </Col>
                                  <Col
                                    md="4"
                                    className="d-flex justify-content-end align-items-center"
                                  >
                                    {!pos[data] && (
                                      <Button
                                        id="addVariable"
                                        className="btn-icon"
                                        color="primary"
                                        size="sm"
                                        outline
                                        style={{
                                          margin: "5px",
                                          padding: "3px",
                                        }}
                                        onClick={async () => {
                                          const pageWidth =
                                            pagesUrl[currentPage - 1]?.width ||
                                            600; // Default width if not available
                                          const pageHeight =
                                            pagesUrl[currentPage - 1]?.height ||
                                            800; // Default height if not available

                                          console.log(
                                            pagesUrl[currentPage - 1]?.width,
                                            pagesUrl[currentPage - 1]?.height
                                          );

                                          // Calculate an appropriate initial font size as a percentage of the page dimensions
                                          const baseFontSize = 18; // The reference font size for typical dimensions
                                          const referenceWidth = 600; // Reference width for the base font size
                                          const referenceHeight = 800; // Reference height for the base font size

                                          // Use the smaller of the width or height scaling factor to determine the font size
                                          const widthScale =
                                            pageWidth / referenceWidth;
                                          const heightScale =
                                            pageHeight / referenceHeight;
                                          const scaleFactor = Math.max(
                                            widthScale,
                                            heightScale
                                          ); // Keep proportions consistent

                                          // Set the initial font size based on the scale factor
                                          const initialFontSize = Math.round(
                                            baseFontSize * scaleFactor
                                          );
                                          setPos({
                                            ...pos,
                                            [data]: {
                                              text: (
                                                tableData[0][data] || data
                                              ).replaceAll(/;/g, ","),
                                              page: currentPage,
                                              x:
                                                // pagesUrl[currentPage - 1]
                                                //   ?.width / 2,
                                                1,
                                              y:
                                                // pagesUrl[currentPage - 1]
                                                //   ?.height / 2,
                                                1,
                                              color: [0, 0, 0],
                                              size: initialFontSize,
                                              fontStyle: "TimesNewRoman",
                                              fontFile: TimesNewRoman,
                                            },
                                          });
                                        }}
                                      >
                                        <Plus size={15} />
                                        <UncontrolledTooltip
                                          placement="bottom"
                                          target="addVariable"
                                        >
                                          Add
                                        </UncontrolledTooltip>
                                      </Button>
                                    )}
                                    {pos[data] && (
                                      <>
                                        <Button
                                          id="removeVariable"
                                          className="btn-icon"
                                          color="primary"
                                          size="sm"
                                          outline
                                          style={{
                                            margin: "5px",
                                            padding: "3px",
                                          }}
                                          onClick={async () => {
                                            setPos((current) => {
                                              const copy = { ...current };
                                              delete copy[data];
                                              return copy;
                                            });
                                          }}
                                        >
                                          <Trash2 size={15} />
                                          <UncontrolledTooltip
                                            placement="bottom"
                                            target="removeVariable"
                                          >
                                            Remove
                                          </UncontrolledTooltip>
                                        </Button>
                                        <ButtonDropdown
                                          className="dropdown-icon-wrapper"
                                          isOpen={
                                            optionsVisible &&
                                            optionsVisible?.visible === true &&
                                            optionsVisible?.key === data
                                          }
                                          toggle={() =>
                                            toggleOptionVisible(data)
                                          }
                                          style={{
                                            width: "max-content !important",
                                            minWidth: "max-content !important",
                                          }}
                                        >
                                          <DropdownToggle
                                            id="edit"
                                            color="primary"
                                            caret
                                            outline
                                            className="btn-icon btn-sm d-flex align-items-center"
                                            style={{
                                              margin: "5px",
                                              padding: "3px",
                                            }}
                                          >
                                            <Edit size={16} />
                                            <UncontrolledTooltip
                                              placement="bottom"
                                              target="edit"
                                            >
                                              Edit
                                            </UncontrolledTooltip>
                                          </DropdownToggle>
                                          <DropdownMenu
                                            end
                                            style={{
                                              width: "max-content !important",
                                              minWidth: "",
                                            }}
                                          >
                                            <div
                                              className="px-2 py-2"
                                              style={{ width: "max-content" }}
                                            >
                                              <div className="mb-2">
                                                <Label
                                                  className="form-label"
                                                  for="font"
                                                >
                                                  Select Font
                                                </Label>
                                                <select
                                                  className="form-select add_fontstyle"
                                                  id="font"
                                                  aria-label="Select Font"
                                                  value={
                                                    fontStyleOptions.filter(
                                                      (option) =>
                                                        option.value ===
                                                        pos[`${data}`]
                                                          ?.fontStyle
                                                    )[0]?.value
                                                  }
                                                  label={
                                                    fontStyleOptions.filter(
                                                      (option) =>
                                                        option.value ===
                                                        pos[`${data}`]
                                                          ?.fontStyle
                                                    )[0]?.label
                                                  }
                                                  style={
                                                    fontStyleOptions.filter(
                                                      (option) =>
                                                        option.value ===
                                                        pos[`${data}`]
                                                          ?.fontStyle
                                                    )[0]?.style
                                                  }
                                                  onChange={async (e) => {
                                                    setPos({
                                                      ...pos,
                                                      [data]: {
                                                        ...pos[`${data}`],
                                                        fontStyle:
                                                          e.target.value,
                                                        fontFile:
                                                          fontStyleOptions.filter(
                                                            (option) =>
                                                              option.value ===
                                                              e.target?.value
                                                          )[0]?.file,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  <option
                                                    defaultValue="Select Font"
                                                    disabled
                                                  >
                                                    Select Font :
                                                  </option>
                                                  {fontStyleOptions.map(
                                                    (option) => (
                                                      <option
                                                        value={option.value}
                                                        style={option.style}
                                                      >
                                                        {option.label}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                              <div className="my-3 d-flex align-items-center color-picker-wrapper">
                                                <Label
                                                  className="form-label m-0"
                                                  for="color"
                                                >
                                                  Select Color :
                                                </Label>
                                                <input
                                                  className="p-0 border-0 ms-2"
                                                  type="color"
                                                  id="color"
                                                  name="color"
                                                  value={
                                                    pos[`${data}`]?.color
                                                      ? rgbToHex(
                                                          pos[`${data}`]?.color
                                                        )
                                                      : [0, 0, 0]
                                                  }
                                                  onChange={async (e) => {
                                                    let hexValue =
                                                      e?.target?.value;
                                                    let rgbValue = [
                                                      ("0x" +
                                                        hexValue[1] +
                                                        hexValue[2]) |
                                                        0,
                                                      ("0x" +
                                                        hexValue[3] +
                                                        hexValue[4]) |
                                                        0,
                                                      ("0x" +
                                                        hexValue[5] +
                                                        hexValue[6]) |
                                                        0,
                                                    ];
                                                    setPos({
                                                      ...pos,
                                                      [data]: {
                                                        ...pos[`${data}`],
                                                        color: rgbValue,
                                                      },
                                                    });
                                                  }}
                                                />
                                              </div>
                                              <div className="mb-2">
                                                <Label
                                                  className="form-label"
                                                  for="size"
                                                >
                                                  Font Size :
                                                </Label>
                                                <Input
                                                  className=""
                                                  placeholder="Enter Font Size"
                                                  type="number"
                                                  id="size"
                                                  max={10000}
                                                  min={5}
                                                  onWheel={(e) =>
                                                    e.currentTarget.blur()
                                                  }
                                                  onFocus={(e) =>
                                                    e.target.select()
                                                  }
                                                  value={pos[`${data}`]?.size}
                                                  onChange={(e) => {
                                                    if (
                                                      parseInt(
                                                        e.target.value || 0
                                                      ) >= 0
                                                    ) {
                                                      setPos({
                                                        ...pos,
                                                        [data]: {
                                                          ...pos[`${data}`],
                                                          size: parseInt(
                                                            e?.target?.value
                                                              .replace(
                                                                /[^0-9]/g,
                                                                ""
                                                              )
                                                              .replaceAll(
                                                                RegExp(
                                                                  "^0+(?!$)",
                                                                  "g"
                                                                ),
                                                                ""
                                                              )
                                                          ),
                                                        },
                                                      });
                                                    }
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </DropdownMenu>
                                        </ButtonDropdown>
                                      </>
                                    )}
                                  </Col>
                                </div>
                              </>
                            )
                          );
                        })}
                    </div>
                  </div>
                </Col>
                <Col md="9">
                  <div>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <Button outline color="primary" onClick={handleZoomOut}>
                        <ZoomOut />
                      </Button>
                      <Button outline color="primary" onClick={handleZoomIn}>
                        <ZoomIn />
                      </Button>
                    </div>
                    <div className="d-flex align-items-center justify-content-center pt-4">
                      {currentPage > 1 && (
                        <div>
                          <ChevronLeft
                            color="#624bff"
                            size={35}
                            onClick={() => {
                              setCurrentPage(currentPage - 1);
                            }}
                          />
                        </div>
                      )}
                      {file && (
                        <div
                          ref={containerRef}
                          className="align-items-center border"
                          style={{
                            overflow: "auto",
                            // border:
                            // maxHeight: 500,
                            // maxWidth: 1000,
                          }}
                        >
                          <div className="position-relative w-100 h-100">
                            <Stage
                              id="stage"
                              ref={stageRef}
                              // width={pagesUrl[currentPage - 1]?.width}
                              // height={pagesUrl[currentPage - 1]?.height}
                              width={stageSize.width} // Dynamic width based on container
                              height={stageSize.height} // Dynamic height based on container
                              scaleX={zoomLevel}
                              scaleY={zoomLevel}
                              onWheel={handleWheel}
                              draggable
                            >
                              <Layer>
                                <URLImage
                                  image={pagesUrl[currentPage - 1]?.base64}
                                />
                                {Object.keys(pos).map((key) => {
                                  if (pos[key]?.page === currentPage) {
                                    return (
                                      <Text
                                        className="position-absolute"
                                        text={tableData[0][key]}
                                        x={pos[key]?.x}
                                        y={pos[key]?.y}
                                        draggable
                                        onDragEnd={(e) => {
                                          handleDragEnd(e, key);
                                        }}
                                        onClick={() => setSelectedTextKey(key)}
                                        fill={`rgb(${pos[key]?.color[0]} ${pos[key]?.color[1]} ${pos[key]?.color[2]})`}
                                        fontSize={pos[key]?.size}
                                        fontFamily={pos[key]?.fontStyle}
                                        font
                                      />
                                    );
                                  } else {
                                    return null;
                                  }
                                })}
                              </Layer>
                            </Stage>
                          </div>
                          {totalPages > 1 && (
                            <div
                              align="center"
                              style={{ color: "#624bff", background: "white" }}
                            >
                              {currentPage} of {totalPages}
                            </div>
                          )}
                        </div>
                      )}

                      {totalPages === 1 ||
                        (currentPage < totalPages && (
                          <div>
                            <ChevronRight
                              size={35}
                              color="#624bff"
                              onClick={() => {
                                setCurrentPage(currentPage + 1);
                              }}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <Card>
            <CardHeader className="header-table mb-75">
              <div className=" fw-bold text-light">Message Preview</div>
            </CardHeader>
            <CardBody>
              <pre>{messagePreview}</pre>
            </CardBody>
          </Card>
        )} */}

        <Modal isOpen={isTestOpen} size="sm" className="modal-dialog">
          <ModalHeader toggle={toggleTestModal} className="modal_header ">
            <h5 className="mb-0">Test Message</h5>
          </ModalHeader>
          <ModalBody>
            <Label>Enter Mobile Number</Label>
            <Input
              name="mobile"
              value={testMobile}
              onChange={(e) => {
                setTestMobile(e.target.value);
              }}
              type="number"
            />
          </ModalBody>
          <ModalFooter className="d-flex justify-content-between align-items-baseline">
            <div>
              <Button
                color="primary"
                className="mx-25"
                onClick={(e) => {
                  sendTestMessage();
                }}
                disabled={isSubmitting}
              >
                Ok
              </Button>
              <Button
                className="mx-25"
                color="secondary"
                onClick={() => {
                  toggleTestModal();
                }}
              >
                Cancel
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={modalSchedule}
          toggle={toggleSchedule}
          className="modal-dialog-centered"
          centered
        >
          <ModalHeader
            toggle={toggleSchedule}
            className="modal_header border-0"
          >
            Schedule Send
          </ModalHeader>
          <ModalBody className="modal_body py-3">
            <div className="position-relative floating-label-content">
              <Input
                type="datetime-local"
                id="schedule-time"
                onChange={inputdata}
                value={formData?.schedule}
                name="schedule"
                min={moment().format("YYYY-MM-DD HH:mm")}
                max={moment(expiry_date).format("YYYY-MM-DDTHH:mm")}
                className="w-100 bg-white fs-16 floating-textarea manual_input"
              />
              <Label className="bg-white position-absolute floating-label">
                Select Date
              </Label>
              <p className="text-danger">{formError?.schedule}</p>
            </div>
          </ModalBody>
          <ModalFooter className="border-0 d-inline pt-5 modal_footer">
            <div className="text-center">
              <Button
                color="secondary"
                onClick={() => {
                  toggleSchedule();
                }}
                className="mx-25 me-4"
              >
                Cancel
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  toggleSchedule();
                }}
                className="mx-25"
                disabled={formError?.schedule ? true : false}
              >
                Ok
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      </>
    </Fragment>
  );
};

export default EditPdf;
